// Kept free of React and react-intl imports so server-side purchase setup can read them.
export const ANNUAL_COUPON = 'hol2026_Web_annual50_Banner';
export const FIRST_MONTH_COUPON = 'BF2026A';
